export class AudioplayerTracking {
    constructor(audioplayer) {
        this._audioPlayer = audioplayer;
        this._firedMilestones = new Set();
        this._dataProviderEl = null;
    }

    setup() {
        this._audioPlayer?.addEventListener("play", () => {
            this._firedMilestones.clear();
            const track = this._audioPlayer.getCurrentTrack();
            const providerData = this.getProviderData();

            this.sendEvent('audioplayer_play', {
                ...providerData,
                track: track?.title ?? 'unavailable',
                source: track?.source ?? 'unavailable',
            });
        });

        this._audioPlayer?.addEventListener("progress", ({ currentTime, duration }) => {
            const percentage = (currentTime / duration) * 100;
            let progress = null;

            switch (true) {
                case percentage >= 90: progress = '90%'; break;
                case percentage >= 75: progress = '75%'; break;
                case percentage >= 50: progress = '50%'; break;
                case percentage >= 25: progress = '25%'; break;
            }

            if (progress && !this._firedMilestones.has(progress)) {
                this._firedMilestones.add(progress);
                const track = this._audioPlayer.getCurrentTrack();
                const providerData = this.getProviderData();

                this.sendEvent('audioplayer_progress', {
                    ...providerData,
                    track: track?.title ?? 'unavailable',
                    source: track?.source ?? 'unavailable',
                    progress: progress,
                });
            }
        });
    }

    getProviderData() {
        if (!this._dataProviderEl) {
            this._dataProviderEl = document.querySelector('[data-audio-tracking-guide]');
        }

        return {
            audioguide: this._dataProviderEl?.dataset?.audioTrackingGuide ?? 'unavailable',
            language: this._dataProviderEl?.dataset?.audioTrackingLanguage ?? 'unavailable',
            version: this._dataProviderEl?.dataset?.audioTrackingVersion ?? 'unavailable',
        };
    }


    sendEvent = (eventName, options = {}) => {
        if (!window.dataLayer) {
            console.log('No dataLayer. Aborting.');
            return;
        }

        if (!eventName) {
            console.log('No eventName given. Aborting.');
            return;
        }

        const data = {
            event: eventName,
            ...options
        };

        window.dataLayer.push(data);
    }
}

